import { token } from '@cp/shared/di';
import { StoreType } from './configureStore';

export const STORE = token<StoreType>('STORE');
